import _ from 'lodash';
import { deserialiseFundingRequirements } from './deserialiseFundingRequirements';
import { deserialiseSignedDocuments } from './signDocumentAction/SignDocumentsHelper';

export type TFundingRequirementsSteps = ReturnType<
    typeof orderFundingRequirements
>;

function orderByPriority(
    funding_requirement:
        | ReturnType<typeof deserialiseFundingRequirements>[0]
        | ReturnType<typeof deserialiseSignedDocuments>[0]
) {
    const PRIORITY_ORDER = {
        BANK_DETAILS: 1,
        PENNY_TRANSFER: 2,
        ONFIDO_VERIFICATION: 3,
        IDNOW: 3,
        MAJOR_SHAREHOLDER_CHECK: 4,
        DEBIT_CARD: 5,
        master_loan_agreement: 6,
        guarantee: 7,
        APPLICANT_CALL: 12
    };
    const LOWEST_PRIORITY = 100;

    return (
        PRIORITY_ORDER[
            funding_requirement.type as keyof typeof PRIORITY_ORDER
        ] || LOWEST_PRIORITY
    );
}

export const orderFundingRequirements = (
    fundingRequirements: ReturnType<typeof deserialiseFundingRequirements>,
    loanDocuments: ReturnType<typeof deserialiseSignedDocuments>
) => {
    const allFundingRequirements = [...fundingRequirements, ...loanDocuments];
    return _.orderBy(allFundingRequirements, orderByPriority, 'asc');
};
